import { Controller } from "@hotwired/stimulus"
import { safeStorageGet, safeStorageSet } from "../utils/safe_storage"

const STORAGE_KEY_DESKTOP = "owner-sidebar-collapsed"
const STORAGE_KEY_MOBILE = "owner-sidebar-mobile-closed"
const DESKTOP_COLLAPSED_CLASS = "owner-dashboard__sidebar--collapsed"
const MOBILE_CLOSED_CLASS = "owner-dashboard__sidebar--mobile-closed"
const DESKTOP_QUERY = "(min-width: 1024px)"

export default class extends Controller {
  static targets = ["toggle", "navBody"]

  connect() {
    this.mq = window.matchMedia(DESKTOP_QUERY)
    this.boundMq = this.onMediaChange.bind(this)
    this.mq.addEventListener("change", this.boundMq)
    this.applyLayoutState()
  }

  disconnect() {
    this.mq.removeEventListener("change", this.boundMq)
  }

  onMediaChange() {
    this.element.classList.remove(DESKTOP_COLLAPSED_CLASS)
    this.element.classList.remove(MOBILE_CLOSED_CLASS)
    this.applyLayoutState()
  }

  applyLayoutState() {
    if (this.mq.matches) {
      if (safeStorageGet(localStorage, STORAGE_KEY_DESKTOP) === "1") {
        this.element.classList.add(DESKTOP_COLLAPSED_CLASS)
      }
    } else if (safeStorageGet(localStorage, STORAGE_KEY_MOBILE) === "1") {
      this.element.classList.add(MOBILE_CLOSED_CLASS)
    }
    this.syncToggle()
    this.syncNavBodyInert()
  }

  syncNavBodyInert() {
    if (!this.hasNavBodyTarget) return

    const el = this.navBodyTarget
    if (this.mq.matches) {
      el.inert = false
      return
    }
    el.inert = this.element.classList.contains(MOBILE_CLOSED_CLASS)
  }

  toggle() {
    if (this.mq.matches) {
      this.element.classList.toggle(DESKTOP_COLLAPSED_CLASS)
      const collapsed = this.element.classList.contains(DESKTOP_COLLAPSED_CLASS)
      safeStorageSet(localStorage, STORAGE_KEY_DESKTOP, collapsed ? "1" : "0")
    } else {
      this.element.classList.toggle(MOBILE_CLOSED_CLASS)
      const closed = this.element.classList.contains(MOBILE_CLOSED_CLASS)
      safeStorageSet(localStorage, STORAGE_KEY_MOBILE, closed ? "1" : "0")
    }
    this.syncToggle()
    this.syncNavBodyInert()
  }

  closeMobileOnLink(event) {
    if (this.mq.matches) return
    if (!event.target.closest("a.owner-dashboard__sidebar-link")) return
    if (this.element.classList.contains(MOBILE_CLOSED_CLASS)) return

    this.element.classList.add(MOBILE_CLOSED_CLASS)
    safeStorageSet(localStorage, STORAGE_KEY_MOBILE, "1")
    this.syncToggle()
    this.syncNavBodyInert()
  }

  syncToggle() {
    if (!this.hasToggleTarget) return

    if (this.mq.matches) {
      const collapsed = this.element.classList.contains(DESKTOP_COLLAPSED_CLASS)
      this.toggleTarget.setAttribute("aria-expanded", String(!collapsed))
      this.toggleTarget.setAttribute(
        "aria-label",
        collapsed ? "Expand owner menu" : "Collapse owner menu"
      )
    } else {
      const closed = this.element.classList.contains(MOBILE_CLOSED_CLASS)
      this.toggleTarget.setAttribute("aria-expanded", String(!closed))
      this.toggleTarget.setAttribute(
        "aria-label",
        closed ? "Show owner menu" : "Hide owner menu"
      )
    }
  }
}
